
export default {
    props: {
        collName: String,
        refName: String,
        columnDefs: Array,
        item: Object,
        readonly: Boolean,
        isDirty: Boolean,
        adderTitle: String,
        adderPlaceholder: String,
        tableTitle: String,
        topFilterFn: Function,
        searchTextFn: {
            type: [String, Function],
            required: true,
        },
        adderLabelFn: {
            type: [String, Function],
            required: true,
        },
        filterFn: Function,
        showOnEmpty: Boolean,
        preselectedChildItem: Object,
    },

    data() {
        return {
            childItem: this.preselectedChildItem ?? null,
            showItem: null,
        };
    },

    computed: {
        refDef() {
            return $.getExpandedRefDef(this.collName, this.refName);
        },
        confirmDialogProps() {
            return !this.isDirty ? undefined : {
                title: this.$t(`confirm.goToDetail.title.${this.refDef.fieldPath}`),
                message: this.$t(`confirm.goToDetail.message`),
            };
        },
    },

    watch: {
        preselectedChildItem(val) {
            if (val) {
                this.childItem = val;
            }
        },
    },

    methods: {
        rowClickFn(ev, item) {
            this.showItem = ((this.showItem || this.childItem) === item) ? null : item;
            this.childItem = null;
        },
        canBeAdded(item) {
            // Works for both simple and compound refs
            return !$.findById(this.item[this.refDef.fieldPath], item.id);
        },
        onAdd(childItem, refFields) {
            // Add item
            this.item[this.refDef.fieldPath].push({
                ...childItem,
                ...refFields,
            });

            let ref;

            if (_.isEmpty(this.refDef.refFields)) {
                // Simple ref (id)
                ref = childItem.id;
            } else {
                // Compound ref ({ id, ... })
                ref = {
                    id: childItem.id,
                    ...refFields,
                };
            }

            // Add ref
            this.item[this.refName].push(ref);

            this.childItem = null;
            this.showItem = null;

            this.$emit('add', ref);
        },
        onRemove(childItem) {
            // Remove item
            $.deleteIn(this.item[this.refDef.fieldPath], childItem);

            let ref;

            if (_.isEmpty(this.refDef.refFields)) {
                // Simple ref (id)
                ref = childItem.id;
            } else {
                // Compound ref ({ id, ... })
                ref = $.findIn(this.item[this.refName], childItem);
            }

            // Remove ref
            $.removeOne(this.item[this.refName], ref);

            this.$emit('remove', ref);
        },
    },
};
